const base = "/tips"
const path = {
    upload_file: `${base}/upload-file`,
    download_file: `${base}/download-file`,
    get_files: `${base}/get-files`
}

export { path }